function RedirectMobileApp() {
  return (
    <div className="w-screen h-screen flex bg-background-app">
      <p className="w-full self-center text-center text-base text-text-primary font-noto-sans-thai">
        Redirect to application...
      </p>
    </div>
  );
}

export default RedirectMobileApp;
